import React from 'react';
import { List, ListItem, ListItemText, Typography, Divider, ListItemIcon } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const DireitoTitular: React.FC = () => {
  const rights = [
    "Direito de acesso, confirmação e correção de seus dados pessoais",
    "Portabilidade dos dados",
    "Direito à correção ou exclusão dos dados pessoais",
    "Direito à restrição do tratamento",
    "Direito de cancelar seu consentimento",
    "Direito de manifestar objeção ao tratamento",
    "Direito à revisão do processo automático de tomada de decisões",
    "Direito de objeção à forma como utilizamos seus dados pessoais para fins de marketing direto ou outra rotina",
    "Direito de obter garantias de segurança dos dados pessoais que utilizamos para transferências e compartilhamento",
    "Direito de reclamar junto ao nosso profissional encarregado pela proteção de dados ou autoridade reguladora",
  ];

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        5. Direitos do Titular
      </Typography>
      <Typography paragraph>
        Para exercer seus direitos de titular, você deverá entrar em contato com a INNOVA PLANO DE SAÚDE através do e-mail: 
        <strong> innova@innovaplanodesaude.onmicrosoft.com </strong>
      </Typography>
      <Typography paragraph>
        Os seguintes direitos podem se aplicar ao seu caso, dependendo da natureza da relação e atividade que requeiram o tratamento de dados pessoais, e da jurisdição onde será feito o tratamento:
      </Typography>

      <List>
        {rights.map((right, index) => (
          <React.Fragment key={index}>
            <ListItem>
              <ListItemIcon>
                <CheckCircle color="warning" />
              </ListItemIcon>
              <ListItemText primary={right} />
            </ListItem>
            {index < rights.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>

      <Typography paragraph>
        De forma a garantir a sua correta identificação como titular dos dados pessoais objeto da solicitação, é possível que solicitemos documentos e informações adicionais que comprovem sua identidade. Nessa hipótese, você será informado previamente.
      </Typography>
    </div>
  );
};

export default DireitoTitular;
